export default __webpack_public_path__ + "static/media/menupfad_arab.6824386b.svg";